export const siteUrl = "https://api.ispanadicto.az/";

export default siteUrl;
